import { getSrcWithParams } from './getSrcWithParams';
export const getSrcSetFromWidths = (src, widths, aspect, options = { crop: false, webp: false }, timestamp) => {
    const l = [];
    for (const w of widths) {
        l.push(getSrcWithParams(w, aspect, src, true, options, timestamp));
    }
    return l.join(', ');
};
//# sourceMappingURL=getSrcSetFromWidths.js.map